import { cn } from "@/shared/lib";

type SteamAvatarProps = {
  name: string | null;
  url: string | null;
  size?: number;
  className?: string;
};

// Аватар Steam в кружке. Имя стоит рядом текстом, поэтому `alt` пустой. Нет аватара —
// первая буква имени.
export const SteamAvatar = ({ name, url, size = 36, className }: SteamAvatarProps) => {
  const classes = cn("shrink-0 rounded-full bg-surface-raised", className);
  return url === null ? (
    <span
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={cn(classes, "flex items-center justify-center font-semibold text-muted")}
    >
      {(name ?? "?").slice(0, 1).toUpperCase()}
    </span>
  ) : (
    <img
      src={url}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      style={{ width: size, height: size }}
      className={cn(classes, "object-cover")}
    />
  );
};
